/**
 * Created by zhaoy on 2020/1/16
 * Desc: 教育公告详情
 */

import React, {Component} from 'react'
import ImagesViewer from "../../components/imagesVIewer";
import {getArrayValue, getIntValue, getSearchParams, getStrValue, isObjEmpty} from "../../utils/common";
import NotifyBoBean from "../../model/NotifyBoBean";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {_baseURL, API} from "../../configs/api.config";
import {Toast} from 'antd-mobile'
import {connect} from 'react-redux'

class BureauBoardDetail extends Component {

    constructor() {
        super();

        this.state = {
            bureauDetail: '',
            previewVisible: false,
        }
    }

    componentWillMount() {
        this.searchParams = getSearchParams(this.props.location.search);

        this.bureauId = this.props.match.params.bureauId;
        this.role = this.props.match.params.role
    }

    componentDidMount() {
        document.title = '教育公告详情';
        this.obtainDetail()
    }

    componentWillUnmount() {

    }

    render() {
        const {previewVisible, bureauDetail} = this.state;

        let enclosureItem = <div></div>
        let pictureUrls = [];
        if (!isObjEmpty(bureauDetail.enclosure) && bureauDetail.enclosure != '[]') {
            enclosureItem =
                <div className='principal-enclosure-layout'>
                    <img src={bureauDetail.enclosure[0]} className='principal-enclosure-img'
                         onClick={this.handlePreview}/>
                    <span className='principal-enclosure-count'>({bureauDetail.enclosure.length}张)</span>
                </div>;

            bureauDetail.enclosure.forEach((enclosure, index) => {
                pictureUrls.push(enclosure)
            })
        }

        const readedList = bureauDetail.readed;
        const unReadList = bureauDetail.unRead;
        const receiveItems = [];

        if (!isObjEmpty(readedList) && readedList != '[]') {
            for (let i = 0; i < readedList.length; i++) {
                receiveItems.push(<span
                    className='notify-detail-modal-read'>{getStrValue(readedList[i], 'stuName') ?
                    getStrValue(readedList[i], 'stuName') : getStrValue(readedList[i], 'teacherName')}</span>)
            }
        }
        if (!isObjEmpty(unReadList) && unReadList != '[]') {
            for (let i = 0; i < unReadList.length; i++) {
                receiveItems.push(<span
                    className='notify-detail-modal-unread'>{getStrValue(unReadList[i], 'stuName') ?
                    getStrValue(unReadList[i], 'stuName') : getStrValue(unReadList[i], 'teacherName')}</span>)
            }
        }

        return (
            <div>
                {previewVisible ?
                    <ImagesViewer onClose={this.handleCancel} urls={pictureUrls}
                                  index={0}
                                  needPoint={pictureUrls.length <= 9}/> : ""}
                <div className='notify-detail-modal-layout'>
                    <div className='notify-detail-modal-content-layout'>
                        <div className='notify-detail-modal-content-header'>
                            <div className='notify-detail-modal-header-tilte'>{bureauDetail.noTitle}</div>
                            <span
                                className={bureauDetail.noStatu === '已读' ?
                                    'notify-item-statuAl' : 'notify-item-statuNo'}>{bureauDetail.noStatu}</span>
                        </div>
                        <div className='notify-detail-modal-content-text'
                             dangerouslySetInnerHTML={{
                                 __html: bureauDetail.noContent ?
                                     bureauDetail.noContent.replaceAll('\n', '<br/>')
                                     : ''
                             }}></div>
                        <div style={{padding: '10px'}}>
                            {enclosureItem}
                        </div>
                        <div className='notify-detail-modal-time'>{bureauDetail.noIssue}</div>
                        <div className='notify-detail-modal-time'>{bureauDetail.noTime}</div>
                        {/*<div className='notify-detail-modal-time'>{bureauDetail.noTime}</div>*/}
                        {/*<div className='gray-line'></div>*/}
                        {/*<div className='common-flex-row-10 common-font-family'>*/}
                            {/*<span style={{color: '#363636', fontSize: 14}}>接收人</span>*/}
                            {/*/!*<span style={{fontSize: '12px', color: '#CD1D1D'}}>未读：{bureauDetail.unRead}</span>*!/*/}
                            {/*<span style={{*/}
                                {/*fontSize: '12px',*/}
                                {/*color: '#666666',*/}
                                {/*marginLeft: '10px'*/}
                            {/*}}>{getIntValue(bureauDetail.readed, 'length')}/{bureauDetail.allCount}</span>*/}
                        {/*</div>*/}
                        {/*<div>*/}
                            {/*{receiveItems}*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        )
    }

    obtainDetail = () => {
        let url = '', params = {};
        url = API.BUREAU_DETAIL_TEACHER;
        let id = this.props.userInfo.user.userFunId;
        let type = this.role==='parent' ? 0 :1;
        if (this.searchParams) {
            if(this.searchParams.personId){
                id = this.searchParams.personId
            }
            if(this.searchParams.type){
                type = this.searchParams.type
            }
        }
        params = {
            bureauId: this.bureauId,
            personId: id,
            type:type
        };

        Toast.loading('', 0);
        fetchGet(url, params).then(response => {
            Toast.hide();
            if (response && response.data) {
                let notifyBoBean = new NotifyBoBean();

                let item = response.data;
                
                if (item) {
                    notifyBoBean.noId = getIntValue(item, 'bureauId');
                    notifyBoBean.noTitle = getStrValue(item, 'bureauTitle');
                    notifyBoBean.enclosure = getArrayValue(item, 'bureauFiles').length > 0
                        ? JSON.parse(getArrayValue(item, 'bureauFiles')) : [];

                    notifyBoBean.unRead = getArrayValue(item, 'unRead');
                    notifyBoBean.readed = getArrayValue(item, 'read');

                    notifyBoBean.allCount = getIntValue(notifyBoBean.unRead, 'length') + getIntValue(notifyBoBean.readed, 'length');
                    notifyBoBean.noContent = getStrValue(item, 'bureauDetails');
                    notifyBoBean.noIssue = getStrValue(item, 'teacherName');
                    notifyBoBean.noTime = getStrValue(item, 'createDate');

                    notifyBoBean.noStatu = ''
                }
                this.setState({
                    bureauDetail: notifyBoBean
                })
            }
        }).catch(error => {
            Toast.hide();
            if (typeof error === 'string') {
                Toast.fail(error)
            } else {
                Toast.fail('请求异常')
            }
        })
    };

    handlePreview = () => {
        this.setState({
            previewVisible: true,
        });
    };

    handleCancel = () => this.setState({previewVisible: false})
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
    listState: {...state.redListState}
});

let mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BureauBoardDetail)
